import {Pipe, PipeTransform, SecurityContext} from "@angular/core";
import {erTomEllerNil, standardStreng} from "../støttefunksjoner/strenger";
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

/** Detekterer video-konferanse-lenker i angitt verdi og viser disse i forenklet form og som klikkbare.
 * Merk at denne pipen må benyttes i kombinasjon med [innerHTML], feks
 * <span [innerHTML]="'en verdi'|konferanselenke"></span>*/
@Pipe({name: 'konferanselenke', pure: true, standalone: true})
export class KonferanselenkePipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) {
    }

    transform(verdi: string | null): SafeHtml | null {
        if (erTomEllerNil(verdi)) return verdi;

        verdi = this.sanitizer.sanitize(SecurityContext.HTML, verdi); //fjerner eventuelle script-tags ol.
        const filterert = finnOgErstattUrler(verdi!);
        return this.sanitizer.bypassSecurityTrustHtml(filterert);
    }
}

/** De ulike url-mønstrene vi gjenkjenner samt navnet på tjenestene de representerer.
 * Bør holdes i synk med lederplan-tjenester/src/main/java/no/systemfabrikken/lederplan/infrastruktur/datatyper/Behandlingssted.java */
const formater = [
    {navn: 'Google Meet', test: /(https?:\/\/)?(meet\.google\.com\/\S+)/g},
    {navn: 'Zoom', test: /(https?:\/\/)?((?:\w+\.)?zoom.us\/\S+)/g},
    {navn: 'Microsoft Teams', test: /(https?:\/\/)?(teams\.(microsoft|live)\.com\/\S+)/g},
]

function finnOgErstattUrler(verdi: string) {
    formater.forEach(kandidat => {
        for (let treff of verdi.matchAll(kandidat.test)) {
            const teksttreff = treff[0];
            const protokoll = standardStreng(treff[1], 'https://');
            const adresse = treff[2];
            verdi = verdi.replace(teksttreff, `<a target="_blank" rel="noopener" href="${protokoll}${adresse}">${kandidat.navn}</a>`)
        }
    })

    //gjør gjenværende URLer klikkbare, regxp treffer alle tekster som starter med http/https og som ikke er prefikset med href="
    //opprinnelig skrevet med negativ lookbehind /(?<!href=")(https?:\/\/\S+)/g men dette støttes ikke før i safari 16.4
    for (let treff of verdi.matchAll(/(?:href=")?(https?:\/\/\S+)/g)) {
        if(!treff[0].startsWith("href")) {
            const url = treff[0];
            verdi = verdi.replace(url, `<a target="_blank" rel="noopener" href="${url}">${url}</a>`)
        }
    }
    return verdi;
}
